export const INDONESIAN_KEMENAG_TAFSIR = {
  id: 820,
  name: 'Tafsir Ringkas Kemenag',
  authorName: 'Kementerian Agama Republik Indonesia',
  slug: 'id-tafsir-ringkas-kemenag',
  languageName: 'indonesian',
  translatedName: {
    name: 'Tafsir Ringkas Kemenag',
    languageName: 'indonesian',
  },
};

export const INDONESIAN_TAHLILI_TAFSIR = {
  id: 821,
  name: 'Tafsir Tahlili',
  authorName: 'Kementerian Agama Republik Indonesia',
  slug: 'id-tafsir-tahlili',
  languageName: 'indonesian',
  translatedName: {
    name: 'Tafsir Tahlili',
    languageName: 'indonesian',
  },
};

export const CUSTOM_TAFSIRS = [INDONESIAN_KEMENAG_TAFSIR, INDONESIAN_TAHLILI_TAFSIR];
